import {
    USERS_FAILURE,
    USERS_REQUEST,
    USERS_SUCCESS,
    USERS_POST_SUCCESS,
    USERS_PATCH_SUCCESS,
    USERS_DELETE_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const userManagementListReducer = (state = initialState, action) => {
    const { type, data, user, id } = action;
    switch (type) {
        case USERS_SUCCESS: return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        };

        case USERS_POST_SUCCESS: return {
            ...state,
            data: [...state.data, user],
        };

        case USERS_PATCH_SUCCESS: return {
            ...state,
            data: state.data.map(u => u.id === user.id ? user : u),
        };

        case USERS_DELETE_SUCCESS: return {
            ...state,
            data: state.data.filter(u => u.id !== id),
        };

        case USERS_REQUEST: return {
            ...state,
            isFetching: true,
        };

        case USERS_FAILURE: return { ...state, isFetching: false };

        default: return state;
    }
};
